import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap';
import { renderHTMLContent } from '../../common/function';

class NextQuestionModal extends Component {
  render() {
    const { showModal, headerText, bodyText, closeFn, moveToNext } = this.props;
    return (
      <Modal
        isOpen={showModal}
        toggle={closeFn}
        className={
          'modal-primary custom_modalpro info-modal-designing' +
          this.props.className
        }
      >
        <ModalHeader toggle={closeFn} className='custom-title'>
          {headerText}
        </ModalHeader>
        <ModalBody className='text-center'>
          <div className='modal-info-view-for-plan '>
          {renderHTMLContent(bodyText, "div")}
            <div className='btn-plan-view view-plan-wrap'>
              <Button
                className='btn btn-primary mr-1 small-btn'
                onClick={closeFn}
              >
                No
              </Button>
              <Button
                className='btn btn-primary small-btn'
                onClick={moveToNext}
              >
                Yes
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default NextQuestionModal;



// WEBPACK FOOTER //
// ./src/views/Common/NextQuestionModal.jsx